/* @flow */

import React from 'react';
import type { QueryProps } from 'react-apollo';

import { smoothScrollTo } from '../../../../lib/smooth-scroll';
import Card from '../../../card/index';
import Event from '../../event/index';
import EventTabs from './tabs';
import LoadingEvents from '../../loading-events/index';
import NoUpcomingEvents from '../../no-upcoming-events/index';
import EventsFooter from '../../events-footer/index';

import style from './index-module.css';

type Props = {
  data: ProfileUpcomingEventsQuery & ProfileQuery & QueryProps,
  currentUser: Object,
  locale: string,
  intl: IntlShape,
  currentPage: number,
  changePage: Function,
  showingUpcomingEvents: boolean,
  showingPastEvents: boolean
};

const Events: Function = (props: Props): React$Element<*> => {
  const { data: { profile, profileUpcomingEvents }, locale, intl, currentUser, changePage, currentPage } = props;

  if (!profileUpcomingEvents.hosting || profileUpcomingEvents.hosting.totalCount === 0) {
    // $FlowIssue: property `className`. Property not found in props of React element `NoUpcomingEvents`, what?!
    return <NoUpcomingEvents {...props} />;
  }

  const list = profileUpcomingEvents.hosting.nodes.map((event) => {
    return <Event key={event.id} data={{ event }} locale={locale} intl={intl} pastEvent={false} />;
  });
  const changePageAndScroll = (payload) => {
    changePage(payload);
    smoothScrollTo(`.${style.list}`);
  };

  return (
    <Card className={style.list}>
      {list}
      <EventsFooter
        profile={profile}
        currentUser={currentUser}
        events={profileUpcomingEvents.hosting && profileUpcomingEvents.hosting.nodes}
        currentPage={currentPage}
        totalCount={profileUpcomingEvents.hosting && profileUpcomingEvents.hosting.totalCount}
        changePage={changePageAndScroll}
      />
    </Card>
  );
};

const UpcomingEvents: Function = (props: Props): React$Element<*> => {
  const { data: { profileUpcomingEvents }} = props;
  let events;

  if (props.data.loading || props.data.error || !profileUpcomingEvents.hosting) {
    events = <LoadingEvents />;
  }
  else {
    events = <Events {...props} />;
  }

  return <div>
    <EventTabs {...props} />
    {events}
  </div>;
};

export default UpcomingEvents;



// WEBPACK FOOTER //
// ./src/components/profile/events/layouts/upcoming.js